import styled from 'styled-components';

const BigH2 = styled.h1`
    font-size: 50px;
    font-weight: 500;
    line-height: 45px;
    color: black;
    text-transform: none;

    @media (max-width: 800px) {
        font-size: 20px;
        line-height: 20px;
    }
`;

export default BigH2;